import ApiClientInstance from '../../common/ApiClient';

export const apiGetAccount = (companyId) => ApiClientInstance.get(
  `api/accountants/company/account${companyId ? `${companyId ? `?company_id=${companyId}` : ''}` : ''}`,
  undefined,
  true,
);
